import axios from 'axios';
import BackendClient from '../backend-client';
import Activity, { modelFactory } from './model';

export default class ActivityClient extends BackendClient {
  constructor(options = {}) {
    super(modelFactory, options);
  }

  list = (start, size, filters = {}, sort, isTIC, pulsoPersId, isPulso = false) => {
    let persid = '';
    if (isTIC) {
      persid = pulsoPersId;
    }
    /* const where = [
      'TYPE in (LOG, ST, CL, CNCL, INIT, NF, ATTACHTDOC, DETACHTDOC, RE,
      RECLAMAR, RO, SEG_USU, TR, ACT_PLANI, APPROVED, REJECTED, SRVY_VALUE)
      AND (((ZNTF_USUARIO_AFECTADO = 1 or("ACT_LOG"."ZNTF_USUARIO_AFECTADO" is null))
      AND ("ACT_LOG"."TYPE" = LOG
      or "ACT_LOG"."TYPE" = SEG_USU or "ACT_LOG"."TYPE" = ATTACHTDOC
      or "ACT_LOG"."TYPE" = DETACHTDOC))
      OR (("ACT_LOG"."ZNTF_USUARIO_AFECTADO" = 0 or("ACT_LOG"."ZNTF_USUARIO_AFECTADO" is null))
      AND ("ACT_LOG"."TYPE" <> LOG) and("ACT_LOG"."TYPE" <> SEG_USU)
      AND ("ACT_LOG"."TYPE" <> ATTACHTDOC) and("ACT_LOG"."TYPE" <> DETACHTDOC)))
      and "ACT_LOG"."INTERNAL" = 0 and "type"."DEL" = 0)',

    ];
    // const where = ['{"$and":
    /[{"type":{"$in":["LOG","ST","CL","CNCL","INIT","NF","ATTACHTDOC",
    "DETACHTDOC","RE","RECLAMAR","RO",
    "SEG_USU","TR","ACT_PLANI","APPROVED","REJECTED","SRVY_VALUE"]}},
    // {"$or":[{"$and":[{"$or":[{"zntf_usuario_afectado":1},{"zntf_usuario_afectado":null}]},
    {"$or":[{"type":"LOG"},{"type":"SEG_USU"},{"type":"ATTACHTDOC"},{"type":"DETACHTDOC"}]}]},
    {"$and":[{"$or":[{"zntf_usuario_afectado":0},{"zntf_usuario_afectado":null}]},
    {"type":{"$distinct":"LOG"}},
    // {"type":{"$distinct":"SEG_USU"}},{"type":{"$distinct":"ATTACHTDOC"}},{"type":
    {"$distinct":"DETACHTDOC"}}]}]},{"internal":0},{"type.del":0}]}'];
    /* if (typeof filters.idTicket === 'number' || typeof filters.idTicket === 'string') {
      where.push(`{"call_req_id":${filters.idTicket}}`);
    } */
    const cancelToken = axios.CancelToken.source();
    const where = JSON.stringify(
      { $and: [{ type: { $in: ['LOG', 'ST', 'CL', 'CNCL', 'INIT', 'NF', 'ATTACHTDOC', 'DETACHTDOC', 'RE', 'RECLAMAR', 'RO', 'SEG_USU', 'TR', 'ACT_PLANI', 'APPROVED', 'REJECTED', 'SRVY_VALUE'] } }, { $or: [{ $and: [{ $or: [{ zntf_usuario_afectado: 1 }, { zntf_usuario_afectado: null }] }, { $or: [{ type: 'LOG' }, { type: 'SEG_USU' }, { type: 'ATTACHTDOC' }, { type: 'DETACHTDOC' }] }] }, { $and: [{ $or: [{ zntf_usuario_afectado: 0 }, { zntf_usuario_afectado: null }] }, { type: { $distinct: 'LOG' } }, { type: { $distinct: 'SEG_USU' } }, { type: { $distinct: 'ATTACHTDOC' } }, { type: { $distinct: 'DETACHTDOC' } }] }] }, { internal: 0 }, { 'type.del': 0 }, { 'ACT_LOG.call_req_id': `cr:${filters.idTicket}` }] },
    );

    const req = this.request('get', null)({
      BackEnd: 'detail',
      WC: where,
      SORT: sort,
      isTIC,
      persid,
      isPulso,
    }, {
      cancelToken: cancelToken.token,
    });

    req.cancel = () => {
      req.cancelled = true;
      cancelToken.cancel('Operation was cancelled by user interaction');
    };

    req.format = this.format.bind(this);

    return req;

    /* return this.req(where.join(' AND '), {
      start,
      size,
      sort,
      resourceName: 'detail',
    }); */
  }
}

export {
  Activity,
};
